import { useMsal } from '@azure/msal-react';
import React, { createRef, useEffect, useState } from 'react';

/**
 * @typedef {{account: (import('@azure/msal-browser').AccountInfo|null), setAccount: (a: (import('@azure/msal-browser').AccountInfo|null)) => void, resetAccount: () => void}} UserDetailsContext
 */


/**
 * @type  React.Context<UserDetailsContext>
 */
// @ts-ignore
export const UserDetailsContext = React.createContext(null);

export const UserDetailsContextProvider = ({
    children
}) => {
    
    const { accounts } = useMsal();

    const [state, setState] = useState({
        account: accounts?.[0] ?? null,
        setAccount: a => setState({ ...state, account: a }),
        resetAccount: () => {
            setState({ ...state, account: accounts?.[0] ?? null })
        }
    });

    useEffect(() => {
        state.setAccount(accounts?.[0] ?? null);
    }, [accounts]);

    return <UserDetailsContext.Provider value={state}>{children}</UserDetailsContext.Provider>
}